import Seedbeds from './Seedbeds/Seedbeds.vue';
import SeedbedsCreateEdit from 'src/views/Pages/Dashboard/Seeding/Seedbeds/SeedbedsCreateEdit.vue';
import SeedTypes from './SeedTypes/SeedTypes.vue';
import SeedingCatching from './SeedingCatching/SeedingCatching.vue';
import ReseedingCatching from './ReseedingCatching/ReseedingCatching.vue';
import SowingMethods from './SowingMethods/SowingMethods.vue';
import SowingMethodsCreateEdit from './SowingMethods/SowingMethodsCreateEdit.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const SeedbedsRoutes = {
  path: 'seeding',
  name: 'sowing.sowing',
  component: MasterTab,
  props: { reference: 'seedingTabs' },
  children: [
    {
      path: 'seedbeds',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.sowing',
          component: Seedbeds,
          meta: {
            prefix_permission: 'seeding_seedbeds',
          },
        },
        {
          path: 'create',
          name: 'sowing.sowing',
          component: SeedbedsCreateEdit,
          meta: {
            prefix_permission: 'seeding_seedbeds',
          },
        },
        {
          path: 'edit',
          name: 'sowing.sowing',
          component: SeedbedsCreateEdit,
          meta: {
            prefix_permission: 'seeding_seedbeds',
          },
        },
      ],
    },
    {
      path: 'sowingmethods',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.sowing',
          component: SowingMethods,
          meta: {
            prefix_permission: 'seeding_sowingmethods',
          },
        },
        {
          path: 'create',
          name: 'sowing.sowing',
          component: SowingMethodsCreateEdit,
          meta: {
            prefix_permission: 'seeding_sowingmethods',
          },
        },
        {
          path: 'edit',
          name: 'sowing.sowing',
          component: SowingMethodsCreateEdit,
          meta: {
            prefix_permission: 'seeding_sowingmethods',
          },
        },
      ],
    },
    {
      path: 'seedtypes',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.sowing',
          component: SeedTypes,
          meta: {
            prefix_permission: 'seeding_seedtypes',
          },
        },
      ],
    },
    {
      path: 'sowingcatchs',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'sowing.sowing',
          component: SeedingCatching,
          meta: {
            prefix_permission: 'seeding_sowingcatchs',
          },
        },
      ],
    },
    {
      path: 'reseedingcatchs',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Siembra',
          component: ReseedingCatching,
          meta: {
            prefix_permission: 'seeding_reseedingcatchs',
          },
        },
      ],
    },
  ],
};

export default SeedbedsRoutes;
